// 1. React and core hooks
import { createContext } from 'react';

// 2. Type imports
import type { AnyWebSocketEvent } from '~/types/websocket';

/**
 * Callback function for WebSocket event subscription.
 * Per §TS.3.2: Explicit function signature (no generic Function type).
 */
export type WebSocketEventHandler = (event: AnyWebSocketEvent) => void;

/**
 * Context value for WebSocket provider with subscription support.
 *
 * Context with undefined to enforce provider usage.
 * Provides subscription mechanism to avoid multiple WebSocket connections.
 */
export interface WebSocketContextValue {
  /** Whether WebSocket is currently connected */
  isConnected: boolean;
  /**
   * Subscribe to WebSocket events.
   * Returns unsubscribe function to clean up handler.
   *
   * @param handler - Callback invoked when events are received
   * @returns Unsubscribe function
   */
  subscribe: (handler: WebSocketEventHandler) => () => void;
}

export const WebSocketContext = createContext<WebSocketContextValue | undefined>(undefined);
